import { REQUIRED_DOCS } from "../../../academic/constants";
import {
  ILanguageCourseApplicationViewBackEndModel,
  ILanguageCourseApplicationViewFrontEndModel,
} from "../../types";
import { EducationType } from "../../../school/constants/types";

export function parseToLanguageCourseApplicationViewFrontEndModel(
  backendData: ILanguageCourseApplicationViewBackEndModel,
  educationType: EducationType,
): ILanguageCourseApplicationViewFrontEndModel {
  const parsedExtraDocs =
    backendData.extraDocs.map((extraDoc) => ({
      ...extraDoc.file,
      isRemovable: false,
    })) || [];

  const parsedReqDocs = backendData.course.requiredDocs.map((reqDoc) => {
    const filledReqDoc = backendData.requiredDocs.find(
      (filledReqDoc) => filledReqDoc.requiredDocId === reqDoc.id,
    );
    const existedDoc = REQUIRED_DOCS.find((d) => d.name === reqDoc.name);

    return {
      received: {
        ...reqDoc,
        name: existedDoc
          ? existedDoc.longName
          : reqDoc.name.charAt(0).toUpperCase() + reqDoc.name.slice(1),
      },
      filled: filledReqDoc,
    };
  });

  const parsedAppForm = backendData.course.applicationForms.map((appForm) => {
    const filledAppForm = backendData.filledForms.find(
      (filledAppForm) => filledAppForm.applicationFormId === appForm.id,
    );

    return {
      received: appForm,
      filled: filledAppForm,
    };
  });

  return {
    injectedData: {
      educationType,
      student: backendData.student,
      branch: {
        name: backendData.branch.name,
        id: backendData.branch.id,
      },
      course: {
        applicationForms: backendData.course.applicationForms,
        applicationLink: backendData.course.applicationLink,
        requiredDocs: backendData.course.requiredDocs,
      },
      filledForms: parsedAppForm,
      requiredDocs: parsedReqDocs,
      extraDocs: parsedExtraDocs,
      comment: backendData.comment,
    },
    step1: {
      isLinkConfirmed: backendData.isLinkConfirmed,
    },
  };
}
